module.exports = __webpack_public_path__ + "chefy-kana.png?08a34a7591989ca497fe83dd1dfe000e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-kana.png
// module id = 38
// module chunks = 0